module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M0 30c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V10H0v20zm20-14h4v4h-4v-4zm0 6h4v4h-4v-4zm-6-6h4v4h-4v-4zm0 6h4v4h-4v-4zm-6-6h4v4H8v-4zm0 6h4v4H8v-4zM30 0H2C.894 0 0 .894 0 2v6h32V2c0-1.106-.894-2-2-2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/calendar-6.js
// module id = 1038
// module chunks = 14